export enum ReservedKeywords {
    STOP = 'stop',
    STOPALL = 'stopall',
    UNSUBSCRIBE = 'unsubscribe',
    END = 'end',
    QUIT = 'quit',
    START = 'start',
    UNSTOP = 'unstop',
    HELP = 'help',
    INFO = 'info',
}

export enum ReservedKeywordCategory {
    UNSUBSCRIBE = 'unsubscribe',
    RESUBSCRIBE = 're-subscribe',
    USER_SUPPORT = 'user support',
}

export type ReservedKeywordsByCategory = {
    category: ReservedKeywordCategory;
    keywords: ReservedKeywords[];
};

export const reservedKeywordsByCategory: ReservedKeywordsByCategory[] = [
    {
        category: ReservedKeywordCategory.UNSUBSCRIBE,
        keywords: [
            ReservedKeywords.STOP,
            ReservedKeywords.STOPALL,
            ReservedKeywords.UNSUBSCRIBE,
            ReservedKeywords.END,
            ReservedKeywords.QUIT,
        ],
    },
    {
        category: ReservedKeywordCategory.RESUBSCRIBE,
        keywords: [ReservedKeywords.START, ReservedKeywords.UNSTOP],
    },
    {
        category: ReservedKeywordCategory.USER_SUPPORT,
        keywords: [ReservedKeywords.HELP, ReservedKeywords.INFO],
    },
];
